import React from "react";
import "./navbar-ont.css";
import { Container, Navbar } from "react-bootstrap";
import styled from "styled-components";
import { Link } from "react-router-dom";

export function OntNavBar() {
  return (
    <div class="top-bar">
      <div class="top-bar-left">
        <div class="menu-icon">☰</div>
        <div class="logo-container-x">{ontLogo}</div>
      </div>
      <Navbar>
        <Container>
          <Navbar.Brand>
            <LinkB to="/home">☰</LinkB>
          </Navbar.Brand>
        </Container>
      </Navbar>

      <div class="user-info">
        <span>สุรเดช อินทราวัน</span>
      </div>
    </div>
  );
}

export default React.memo(OntNavBar);

export const ontLogo = (
  <svg width="380" height="40" viewBox="15 50 1200 50">
    {/* <!-- Circle with radiating lines --> */}
    <circle
      cx="65"
      cy="75"
      r="45"
      fill="none"
      stroke="#074207"
      stroke-width="4"
    />
    {/* <!-- Inner circles --> */}
    <circle
      cx="65"
      cy="75"
      r="35"
      fill="none"
      stroke="#2d3748"
      stroke-width="2"
    />
    <circle
      cx="65"
      cy="75"
      r="25"
      fill="none"
      stroke="#2d3748"
      stroke-width="2"
    />
    <circle
      cx="65"
      cy="75"
      r="15"
      fill="none"
      stroke="#2d3748"
      stroke-width="2"
    />
    {/* <!-- Tower in center --> */}
    <rect x="60" y="65" width="10" height="20" fill="#2d3748" />
    <polygon points="55,65 65,55 75,65" fill="#2d3748" />
    {/* <!-- ONT Text --> */}
    <text
      x="140"
      y="95"
      font-size="70"
      font-weight="bold"
      fill="#074207"
      letter-spacing="5"
    >
      ONT
    </text>
    {/* <!-- Underline --> */}
    <line
      x1="140"
      y1="105"
      x2="650"
      y2="105"
      stroke="#2d3748"
      stroke-width="6"
    />
    {/* <!-- Open Network Telerad --> */}
    <text x="140" y="135" font-size="28" fill="#2d3748" letter-spacing="2">
      Open Network Telerad
    </text>
  </svg>
);

const LinkB = styled(Link)`
  text-decoration: none;
  display: flexbox;
  margin-top: 0px;
  margin-left: 0px;
  padding-left: 1px;
  &:hover {
    // background :yellow;
  }
`;
